<template>
  <div class="overall">
    <!-- 步骤条盒子 -->
    <div class="steps-box">
      <!-- 步骤条 -->
      <div class="Article-steps" :class="stepList.length <= activeIndex ? 'step-over':''">
        <!-- 步骤条背景进度条 -->
        <div class="line">
          <span
            class="plan"
            :style="status == '7'?'':`width:${activeIndex*(100/(stepList.length - 1)) - (100/(stepList.length - 1))}%`"
          ></span>
          <!-- `width:${activeIndex*(100/(stepList.length - 1)) - (100/(stepList.length - 1)/2)}%` -->
        </div>
        <!-- 每步部分 -->
        <span
          class="step"
          v-for="(i,index) in stepList"
          :key="index"
          :class="activeIndex == i.stepIndex || i.stepIndex<=activeIndex ? 'step-active':''"
        >
          <span :class="status == '7'?'step-num2':'step-num1'" :style="index == '0'?'left:5%;margin-left: 0;':''">
            <span class="num">
               <img src="../../activity/img/icon8.png" alt="" class="icon" v-if="(i.stepIndex<=activeIndex)&&i.title == '任务失败'">
               <img src="../../activity/img/icon6.png" alt="" class="icon" v-else-if="(i.stepIndex<=activeIndex)&&i.title == '任务中'">
               <img src="../../activity/img/icon9.png" alt="" class="icon" v-else-if="(i.stepIndex<=activeIndex)&&(i.title == '即将开始'||i.title == '积分发放中'||i.title == '待领取任务')">
               <img src="../../activity/img/icon7.png" alt="" class="icon" v-else-if="i.stepIndex<=activeIndex">
            </span>
          </span>
          <p class="title" :style="(index == '0'||i.title == '积分发放中')?'margin-left: 0;':''">{{i.title}}</p>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //当前位置
      activeIndex: 0,
      //步骤条步数
      stepList:[],
      // 阶梯 PK
      stepList1:[{stepIndex:1,title:"待领取任务"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"发放积分"}],
      stepList2:[{stepIndex:1,title:"领取任务"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"发放积分"}],
      stepList3:[{stepIndex:1,title:"领取任务"},{stepIndex:2,title:"即将开始"},{stepIndex:3,title:"完成任务"},{stepIndex:4,title:"发放积分"}],
      stepList4:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"任务中"},{stepIndex:3,title:"发放积分"}],
      stepList5:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"任务失败"}],
      stepList6:[{stepIndex:1,title:"领取任务"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"积分发放中"}],
      // 首单 复销激活
      stepList7:[{stepIndex:1,title:"即将开始"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"发放积分"}],
      stepList8:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"任务中"},{stepIndex:3,title:"发放积分"}],
      stepList9:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"任务失败"}],
      stepList10:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"积分发放中"}],
      stepList11:[{stepIndex:1,title:"开始任务"},{stepIndex:2,title:"完成任务"},{stepIndex:3,title:"发放积分"}],
    };
  },

watch:{
    status(n,o){ //n为新值,o为旧值;
    console.log('watch-n',n)
    this.status = n;
    this.step()
    }
},
  props: {
    status:String,
    type:String
  },
  created(){
    this.step()
  },
  methods: {
    step(){
      console.log("状态",this.status)
      console.log('类型',this.type)
      if(this.type == '1'||this.type == '2'){
        switch (this.status) {
          case "1":
           this.activeIndex = "1"
           this.stepList = this.stepList7
          break;

          case "3":
           this.activeIndex = "2"
           this.stepList = this.stepList8
          break;

          case "4":
           this.activeIndex = "3"
           this.stepList = this.stepList10
          break;

          case "5":
           this.activeIndex = "2"
           this.stepList = this.stepList9
          break;

          case "6":
           this.activeIndex = "3"
           this.stepList = this.stepList11
          break;

        default:
          break;
        }
      }else{
        switch (this.status) {
        // 即将开始-无需领取
        case "1":
          this.activeIndex = "2"
          this.stepList = this.stepList3
          break;
        // 进行中-未领取
        case "2":
          this.activeIndex = "1"
          this.stepList = this.stepList1
          break;
        //  进行中-已领取
        case "3":
          this.activeIndex = "2"
          this.stepList = this.stepList4
          break;
        // 积分发放中
        case "4":
          this.activeIndex = "3"
          this.stepList = this.stepList6
          break;
        // 失败
        case "5":
          this.activeIndex = "2"
          this.stepList = this.stepList5
          break;
        // 已完成（积分已发放）
        case "6":
          this.activeIndex = "3"
          this.stepList = this.stepList2
          break;
        // 已过期
        case "7":
           this.activeIndex = "0"
           this.stepList = this.stepList2
          break;
        // 即将开始-已领取
        case "8":
           this.activeIndex = "2"
           this.stepList = this.stepList3
          break;
        // 即将开始-待领取
        case "9":
           this.activeIndex = "1"
           this.stepList = this.stepList1
          break;

        default:
          break;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.steps-box {
  user-select: none;
margin-top: 0.4rem;
  position: relative;
  // <!-- 步骤条背景进度条 -->
  .line {
    display: block;
    margin: 0 auto;
    position: absolute;
    top: 0.18rem;
    left: 10%;
    background: #ccc;
    width: 85%;
    height: 2px;
    overflow: hidden;
    .plan {
      position: absolute;
      top: 0;
      left: 0;
      height: 2px;
      transition: 0.5s;
      background: #E74715;
    }
  }
  .Article-steps {
    display: flex;
    justify-content: space-between;
    .step {
        text-align: center;
      .title {
        font-size: 0.24rem;
        font-weight: bold;
        color: #808080;
        margin-top: 0.6rem;
        margin-left: 0.4rem;
      }
      .step-num1,.step-num2{
        width: 0.36rem;
        height: 0.36rem;
        display: inline-block;
        position: absolute;
        color: white;
        font-weight: bold;
        transition: 0.5s;
      }
      .step-num1 {
        background: url("../../activity/img/icon10.png") center no-repeat;
        background-size: contain;
      }
      .step-num2 {
        background: url("../../activity/img/icon12.png") center no-repeat;
        background-size: contain;
        }
    }
  }

  //当前所在位置样式
  .step-active {
    .step-num {
    //   background: #DD2B1E !important;
    //   transform: rotate(90deg);
      .num {
        // transform: rotate(-90deg);
      }
    }
    .title {
      color: #DD2B1E !important;
    }
  }

  //全部完成样式
  .step-over {
    .plan {
    //   background: #91f062 !important;
    }
    .step-num {
    //   background: #67c23a !important;
    }
    .title {
    //   color: #67c23a !important;
    }
  }

  .icon{
          width: 0.36rem;
    height: 0.36rem;
  }

  .img1{
      background: url("../../activity/img/icon7.png") center no-repeat !important;
      background-size: contain !important;
  }
  .img2{
      background: url("../../activity/img/icon8.png") center no-repeat !important;
      background-size: contain !important;
  }
}
</style>